import React from 'react';
import './App.css';
import Search from "./Search";


function App() {
  return (
    <div className="App">
      <Search />
    </div>
  );
}

export default App;
